import React from 'react';
import { connect } from 'react-redux';
import { Dialog } from '@mui/material';
import { IAppState } from '../../../state/reducers';
import {
  IProps,
  IStateProps,
  IDispatchProps,
} from './interfaces';
import {
  clearPrePostRollSelection,
} from '../../VirtualClipper/state/prePostRollSelection';
import PrePostRollSelection from './PrePostRollSelection/component';

const PrePostRollDialog: React.FunctionComponent<IProps> = (props: IProps) => {
  const {
    isOpen,
    clearPrePostRollSelectionConnect,
  } = props;

  return (
    <Dialog
      open={isOpen}
      fullWidth
      maxWidth="md"
      TransitionProps={{
        onExited: clearPrePostRollSelectionConnect,
      }}
    >
      <PrePostRollSelection />
    </Dialog>
  );
};

const mapStateToProps = (state: IAppState): IStateProps => ({
  isOpen: state.prePostRollSelection.isOpen,
});

const mapDispatchToProps: IDispatchProps = {
  clearPrePostRollSelectionConnect: clearPrePostRollSelection,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PrePostRollDialog);
